import { IntlShape } from 'react-intl';
import { getNdcs } from '../../api/documents/noteDeCoupures';
import { NdcReadDTO } from '../../api/dto';
import { makeNdcFilter } from '../../lib/filters/ndc';
import { AsyncAutocompleteFormElement, TFormElement } from '../types';
import { UiSchemaType } from '../UiSchemaType';
import { documentTypeProperties } from './document';

interface NoteDeCoupureSchemaParameters extends Pick<AsyncAutocompleteFormElement, 'path' | 'label' | 'required'> {
    multiple?: boolean;
}

export const noteDeCoupureSchema = (
    { path, label, required, multiple }: NoteDeCoupureSchemaParameters,
    intl: IntlShape
): TFormElement => ({
    type: UiSchemaType.AUTOCOMPLETE_ASYNC,
    label,
    path,
    required,
    typeProperties: documentTypeProperties({
        fetchOptions: async (query) => {
            const result = await getNdcs({ filter: makeNdcFilter(query) });
            return result.content;
        },
        getOptionLabel: (ndc: NdcReadDTO) =>
            intl.formatMessage({ id: 'ndc.titleExisting' }, { ndcNumber: ndc.ndcNumber }),
        label: intl.formatMessage({ id: 'ndc.name' }),
        multiple,
        autocompletePropsOverrides: {
            disableCloseOnSelect: true,
        },
    }),
});
